import React, {PureComponent} from 'react';
import {objectType} from '../../constants/proptype-validation';
import Loader from '@adsk/bim360-matrix-react-loader';
import IssuesPanelContainer from './IssuesPanelContainer';

export default class IssuesPanelWrapper extends PureComponent {
  render() {
    const {issueType} = this.props.params;

    return issueType ? <IssuesPanelContainer {...this.props} /> : <Loader />;
  }
}

IssuesPanelWrapper.displayName = 'IssuesPanelWrapper';

IssuesPanelWrapper.propTypes = {
  params: objectType.isRequired
};
